import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, Typography, Tag, Button, Row, Col, Space, message } from 'antd';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { tagActionStart, tagActionError, getTagAction } from '../../core/data/redux/modules/tag/actions';
import { getTagById } from '../../services/adminServices/tag';

const { Title, Paragraph, Text } = Typography;

const TagDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { tag, loading } = useSelector((state: any) => state.tag || { tag: null, loading: false });
  const [localTag, setLocalTag] = useState<any>(null);

  useEffect(() => {
    fetchTag();
    // eslint-disable-next-line
  }, [id]);

  const fetchTag = async () => {
    dispatch(tagActionStart());
    try {
      const res = await getTagById(id!);
      if (res.error) throw new Error(res.message);
      dispatch(getTagAction(res.data));
      setLocalTag(res.data);
    } catch (err: any) {
      dispatch(tagActionError(err.message));
      message.error(err.message);
    }
  };

  if (loading || !localTag) return <Card loading style={{ margin: 24 }} />;

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>Tag Details</Title>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Title level={5}>Basic Information</Title>
              <Paragraph><Text strong>Name:</Text> {localTag.name}</Paragraph>
              <Paragraph><Text strong>Status:</Text> <Tag color={localTag.status === 'active' ? 'green' : 'red'}>{localTag.status}</Tag></Paragraph>
            </Col>
          </Row>
          <Space style={{ marginTop: 32 }}>
            <Link to="/admin/tag/list-tags">
              <Button>Back to List</Button>
            </Link>
            {/* Optionally, add edit button/modal here */}
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default TagDetail; 